var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSunny(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "0%",
    x2: "100%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FCD35C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FBBC04"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 14,
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FBBC04",
    d: "m17.125 2.085 1.595-.813c1.24-.633 2.739-.125 3.386 1.146l.832 1.635a2.57 2.57 0 0 0 1.82 1.378l1.748.32c1.36.248 2.287 1.577 2.093 3.002l-.249 1.832a2.74 2.74 0 0 0 .696 2.23l1.234 1.33a2.75 2.75 0 0 1 0 3.71l-1.234 1.33a2.74 2.74 0 0 0-.696 2.23l.25 1.832c.193 1.425-.734 2.754-2.094 3.002l-1.748.32a2.57 2.57 0 0 0-1.82 1.378l-.832 1.635c-.647 1.271-2.145 1.779-3.386 1.146l-1.595-.812a2.467 2.467 0 0 0-2.25 0l-1.595.812c-1.24.633-2.738.125-3.386-1.146l-.832-1.635a2.571 2.571 0 0 0-1.82-1.378l-1.748-.32c-1.36-.248-2.286-1.577-2.093-3.002l.249-1.832a2.741 2.741 0 0 0-.695-2.23l-1.235-1.33a2.75 2.75 0 0 1 0-3.71l1.235-1.33a2.74 2.74 0 0 0 .695-2.23L3.4 8.753c-.192-1.425.734-2.754 2.094-3.002l1.749-.32a2.57 2.57 0 0 0 1.82-1.378l.831-1.635C10.542 1.147 12.04.64 13.28 1.272l1.596.813c.709.36 1.54.36 2.249 0",
    opacity: 0.35
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSunny);
export default __webpack_public_path__ + "static/media/sunny.1de994b97dd31c483b2ad00ec6f4036a.svg";
export { ForwardRef as ReactComponent };